export const STATUS_UNCHANGED = 'STATUS_UNCHANGED';
export const STATUS_REQUESTED = 'STATUS_REQUESTED';
export const STATUS_RESOLVED = 'STATUS_RESOLVED';
export const STATUS_ERROR = 'STATUS_ERROR';
